module.exports = __webpack_public_path__ + "img/tu3.59938120.png";